import { render, staticRenderFns } from "./Samcart.vue?vue&type=template&id=0fc16028&scoped=true"
import script from "./Samcart.vue?vue&type=script&lang=js"
export * from "./Samcart.vue?vue&type=script&lang=js"
import style0 from "./Samcart.vue?vue&type=style&index=0&id=0fc16028&prod&lang=scss&scoped=true"
import style1 from "./Samcart.vue?vue&type=style&index=1&id=0fc16028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc16028",
  null
  
)

export default component.exports